import {
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Row,
  Space,
  Table,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Restore } from '../../Images/RestoreNew.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';

import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import {
  addBundleItem,
  fetchBundleListExist,
  restoreBundleItem,
} from '../../slices/warehouse-bundle-outward';

export default function WarehouseBundleForOutWard() {
  let navigate = useNavigate();
  const [selectedRowKeysAdd, setSelectedRowKeysAdd] = useState([]); // Add Table
  const [selectedRowKeysRestore, setSelectedRowKeysRestore] = useState([]); // Restore Table
  const [dropdownVisibleOne, setDropdownVisibleOne] = useState(false);
  const [dropdownVisibleTwo, setDropdownVisibleTwo] = useState(false);
  const dispatch = useDispatch();
  const { data = [], totalRecord, status } = useSelector(state => state.customer);
  const [searchRestore, setSearchRestore] = useState('');
  const [searchAdd, setSearchAdd] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const { id, outward_id } = useParams();
  const [outwardData, setOutwardData] = useState(null);
  const [restoreData, setRestoreData] = useState([]);
  const [buttonLoading, setBtnLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalAddPage, setTotalAddPage] = useState();
  const [totalRestorePage, setTotalRestorePage] = useState();
  const [pagesize, setPageSize] = useState(5000);
  const [pageRestoreList, setPageRestoreList] = useState(1);
  const [pagesizeRestoreList, setPageSizeRestoreList] = useState(5000);
  const fetchBundleOutward = async () => {
    try {
      dispatch(
        fetchBundleListExist({
          page, // Use correct variable 
          pagesize,
          ...(searchAdd && { search: searchAdd }), // Make sure this is the right search variable
          bundleId: id,
          added: 'False', // For outward bundles - assuming this is correct
          bundleOutwardId: outward_id,
        }),
      )
        .unwrap()
        .then(response => {
          if (response) {
            setOutwardData(response?.results?.data);
            setTotalAddPage(response?.count);
          }
        })
        .catch(error => {
          console.error('Fetch Bundle Outward Failed:', error);
        });
    } catch (error) {
      if (typeof error === 'object' && error !== null) {
        const messages = [];
        for (const key in error) {
          if (Array.isArray(error[key])) {
            messages.push(`${key}: ${error[key].join(', ')}`);
          }
        }

        if (messages.length > 0) {
          message.error(messages.join('; '));
        } else {
          message.error('An unknown error occurred.');
        }
      } else if (typeof error === 'string') {
        message.error(error);
      } else if (error instanceof Error) {
        message.error(error.message);
      } else {
        message.error('An unknown error occurred.');
      }
    }
  };

  const fetchBundleRestoreList = async () => {
    try {
      dispatch(
        fetchBundleListExist({
          page: pageRestoreList,
          pagesize: pagesizeRestoreList,
           ...(searchRestore && { search: searchRestore }),
          bundleId: id,
          added: 'True',
          bundleOutwardId: outward_id,
        }),
      )
        .unwrap()
        .then(response => {
          if (response) {
            setRestoreData(response?.results?.data.bundles);
            setTotalRestorePage(response?.count);
          }
        })
        .catch(error => {
          console.error('Fetch Restore List Failed:', error);
        });
    } catch (error) {
      if (typeof error === 'object' && error !== null) {
        const messages = [];
        for (const key in error) {
          if (Array.isArray(error[key])) {
            messages.push(`${key}: ${error[key].join(', ')}`);
          }
        }

        if (messages.length > 0) {
          message.error(messages.join('; '));
        } else {
          message.error('An unknown error occurred.');
        }
      } else if (typeof error === 'string') {
        message.error(error);
      } else if (error instanceof Error) {
        message.error(error.message);
      } else {
        message.error('An unknown error occurred.');
      }
    }
  };

  useEffect(() => {
    fetchBundleRestoreList();
  }, [id, pageRestoreList, pagesizeRestoreList, searchRestore]);

  useEffect(() => {
    fetchBundleOutward();
  }, [id, page, pagesize, searchAdd]);

  const [checkedListOne, setCheckedListOne] = useState([
    'bundle_no',
    'profile_description',
    'profile',
    'length',
    'weight',
    'avg_weight',
    'packing_date_time',
    'restore',
    'pieces',
    'action',
  ]);
  const [checkedListTwo, setCheckedListTwo] = useState([
    'bundle_no',
    'profile_description',
    'profile',
    'length',
    'weight',
    'avg_weight',
    'packing_date_time',
    'restore',
    'pieces',
    'action',
  ]);

  const handleAdd = bundleId => {
    const values = { bundle_id: [bundleId], outward_id: Number(outward_id) };
    const restoreData = [bundleId]; // Pass the bundleId directly
    dispatch(addBundleItem({ values }))
      .unwrap()
      .then(result => {
        message.success('Bundle Item Added Successfully!');
        setSelectedRowKeysAdd([]);
        setSelectedRowKeysRestore([]);
        fetchBundleRestoreList();
        fetchBundleOutward();
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };
  const handleRestore = bundleId => {
    const values = { bundle_id: [bundleId], outward_id: Number(outward_id) };
    dispatch(restoreBundleItem({ values }))
      .unwrap()
      .then(result => {
        fetchBundleOutward();
        fetchBundleRestoreList();
        message.success('Bundle Item Restore Successfully!');
        setSelectedRowKeysRestore([]);
        setSelectedRowKeysAdd([]);
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };

  const handleColumnVisibilityChangeOne = checkedValues => {
    setCheckedListOne(checkedValues);
  };

  const handleColumnVisibilityChangeTwo = checkedValues => {
    setCheckedListTwo(checkedValues);
  };
  const handleAddMultiple = () => {
    const values = {
      bundle_id: selectedRowKeysAdd,
      outward_id: Number(outward_id),
    };
    dispatch(addBundleItem({ values }))
      .unwrap()
      .then(result => {
        message.success('Bundle Item Added Successfully!');
        setSelectedRowKeysAdd([]);
        fetchBundleRestoreList();
        fetchBundleOutward();
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };
  const handleRestoreMultiple = () => {
    const values = {
      bundle_id: selectedRowKeysRestore,
      outward_id: Number(outward_id),
    };
    dispatch(restoreBundleItem({ values }))
      .unwrap()
      .then(result => {
        fetchBundleOutward();
        fetchBundleRestoreList();
        message.success('Bundle Item Restore Successfully!');
        setSelectedRowKeysRestore([]);
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };

  
  const columnsOne = [
    {
      title: 'Bundle No',
      dataIndex: 'bundle_no', // Use a unique key for the serial number
      key: 'bundle_no',
    },
    {
      title: 'Profile Description',
      dataIndex: 'profile_description',
      key: 'profile_description',
    },
    {
      title: 'Profile',
      dataIndex: 'profile',
      key: 'profile',
    },
    {
      title: 'Length (MM)',
      dataIndex: 'length',
      key: 'length',
    },

    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
    },
    {
      title: 'Weight (Kg)',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Avg Weight (Kg)',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
      render: value => value?.toFixed(3),
    },
    {
      title: 'Packing Date Time',
      dataIndex: 'packing_date_time',
      key: 'packing_date_time',
      render: text => {
        const formatted = dayjs(text)?.isValid()
          ? dayjs(text)?.format('DD-MM-YYYY hh:mm A')
          : '-';
        return formatted;
      },
    },

    {
      title: 'Restore',
      key: 'restore',
      render: (_, record) => (
        <Space>
          <Restore
            style={{ cursor: 'pointer' }}
            onClick={() => handleRestore(record.id)}
          />
        </Space>
      ),
    },
  ];
  const columnsTwo = [
    {
      title: 'Bundle No',
      dataIndex: 'bundle_no', // Use a unique key for the serial number
      key: 'bundle_no',
    },
    {
      title: 'Profile Description',
      dataIndex: 'profile_description',
      key: 'profile_description',
    },
    {
      title: 'Profile',
      dataIndex: 'profile',
      key: 'profile',
    },
    {
      title: 'Length (MM)',
      dataIndex: 'length',
      key: 'length',
    },

    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
    },
    {
      title: 'Weight (Kg)',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Avg Weight (Kg)',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
      render: value => value?.toFixed(3),
    },
    {
      title: 'Packing Date Time',
      dataIndex: 'packing_date_time',
      key: 'packing_date_time',
      render: text => {
        const formatted = dayjs(text).isValid()
          ? dayjs(text).format('DD-MM-YYYY hh:mm A')
          : '-';
        return formatted;
      },
    },

    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <PlusOutlined
            style={{ cursor: 'pointer' }}
            onClick={() => handleAdd(record.id ? record.id : record?.bundle_id)} // Call handleAdd with record.id
          />
        </Space>
      ),
    },
  ];
  const filteredColumnsOne = columnsOne.filter(column =>
    checkedListOne.includes(column.key),
  );

  const filteredColumnsTwo = columnsTwo.filter(column =>
    checkedListTwo.includes(column.key),
  );
  const rowSelectionAdd = {
    selectedRowKeys: selectedRowKeysAdd,
    onChange: selectedKeys => {
      setSelectedRowKeysAdd(selectedKeys);
      setSelectedRowKeysRestore([]); // Deselect in restore table
    },
  };

  const rowSelectionRestore = {
    selectedRowKeys: selectedRowKeysRestore,
    onChange: selectedKeys => {
      setSelectedRowKeysRestore(selectedKeys);
      setSelectedRowKeysAdd([]); // Deselect in add table
    },
  };

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
  }));

  const handleTableChange = (pagination, filters, sorter) => {

    setPage(pagination.current); // Update page number
    setPageSize(pagination.pageSize);

    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };

  const handletableRestoreListchange = (pagination, filters, sorter) => {
    setPageRestoreList(pagination.current); // Update page number
    setPageSizeRestoreList(pagination.pageSize);

    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };


  const debounceTimeout = useRef(null);

  const handleSearchRestore = e => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setSearchRestore(e.target.value);
      setPage(1);
    }, 100); // 300ms delay
  };
  const handleSearchAdd = e => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setSearchAdd(e.target.value);
      setPage(1);
    }, 100); // 300ms delay
  };
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'bundle_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'bundle_number';
    }
    if (sortField === 'bundle_number' && sortOrder === 'descend') {
      sortingEnumKey = '-bundle_number';
    }
    if (sortField === 'section' && sortOrder === 'ascend') {
      sortingEnumKey = 'section';
    }
    if (sortField === 'section' && sortOrder === 'descend') {
      sortingEnumKey = '-section';
    }
    if (sortField === 'die_image' && sortOrder === 'ascend') {
      sortingEnumKey = 'die_image';
    }
    if (sortField === 'die_image' && sortOrder === 'descend') {
      sortingEnumKey = '-die_image';
    }
    if (sortField === 'item_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'item_name';
    }
    if (sortField === 'item_name' && sortOrder === 'descend') {
      sortingEnumKey = '-item_name';
    }
    if (sortField === 'length' && sortOrder === 'ascend') {
      sortingEnumKey = 'length';
    }
    if (sortField === 'length' && sortOrder === 'descend') {
      sortingEnumKey = '-length';
    }
    if (sortField === 'pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'pieces';
    }
    if (sortField === 'pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-pieces';
    }
    if (sortField === 'weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'weight';
    }
    if (sortField === 'weight' && sortOrder === 'descend') {
      sortingEnumKey = '-weight';
    }
    if (sortField === 'avg' && sortOrder === 'ascend') {
      sortingEnumKey = 'avg';
    }
    if (sortField === 'avg' && sortOrder === 'descend') {
      sortingEnumKey = '-avg';
    }
    if (sortField === 'packing_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'packing_date';
    }
    if (sortField === 'packing_date' && sortOrder === 'descend') {
      sortingEnumKey = '-packing_date';
    }
    if (sortField === 'alloy' && sortOrder === 'ascend') {
      sortingEnumKey = 'alloy';
    }
    if (sortField === 'alloy' && sortOrder === 'descend') {
      sortingEnumKey = '-alloy';
    }
    if (sortField === 'temper' && sortOrder === 'ascend') {
      sortingEnumKey = 'temper';
    }
    if (sortField === 'temper' && sortOrder === 'descend') {
      sortingEnumKey = '-temper';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    if (sortField === 'customer' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer';
    }
    if (sortField === 'customer' && sortOrder === 'descend') {
      sortingEnumKey = '-customer';
    }
    if (sortField === 'total_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_weight';
    }
    if (sortField === 'total_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-total_weight';
    }
    if (sortField === 'total_pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_pieces';
    }
    if (sortField === 'total_pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-total_pieces';
    }
    if (sortField === 'total_bundles' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_bundles';
    }
    if (sortField === 'total_bundles' && sortOrder === 'descend') {
      sortingEnumKey = '-total_bundles';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };
  
  const columnMenuOne = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedListOne}
          onChange={handleColumnVisibilityChangeOne}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="bundle_no">Bundle No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_description">
                Profile Description
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Lenght(MM)</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="weight">Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="avg_weight">Avg Weight(Kg)</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_date_time">Packing Date Time</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="restore">Restore</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const columnMenuTwo = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedListTwo}
          onChange={handleColumnVisibilityChangeTwo}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="bundle_no">Bundle No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_description">
                Profile Description
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Lenght(MM)</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="weight">Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="avg_weight">Avg Weight(Kg)</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_date_time">Packing Date Time</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div>
        <div className="sticyaction">
          <div className="sticky-header">
            <Row
              className="pagenamerow mb-0 "
              justify="space-between"
              align="middle"
            >
              <Col>
                <h2 style={{ margin: 0 }}>Add Warehouse Bundle For OutWard</h2>
                <div className="bredcrumbwrp">
                  <Link className="back" onClick={(() => { navigate(-1) })}>
                    <Back /> BACK
                  </Link>
                  <Breadcrumb
                    items={[
                      { title: <Link to="/dashboard">Home</Link> },
                      { title: 'Add Warehouse Bundle For OutWard' },
                    ]}
                  />
                </div>
              </Col>
              <Col>
                <Space size="small">
                  <Tooltip title="Back">
                    <Link
                      to={`/finalize-warehouse-bundle-for-outward/${id}/${outward_id}`}
                      className="back"
                    >
                      <Button type="primary" icon={<Back />}>
                        Back
                      </Button>
                    </Link>
                  </Tooltip>
                </Space>
              </Col>
            </Row>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            textAlign: 'center',
            padding: '25px',
            backgroundColor: '#e0f2f7',
            marginTop: '20px',
          }}
        >
          <div>
            {' '}
            <div style={{ fontWeight: 'bold' }}>Sr No.</div>
            <p>1</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Profile Description</div>
            <p>{outwardData?.profile_description}</p>
          </div>

          <div>
            {' '}
            <div style={{ fontWeight: 'bold' }}>Total Bundles</div>
            <p>{outwardData?.total_bundles}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Total Pieces</div>
            <p>{outwardData?.total_pieces}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Total Weight</div>
            <p>{outwardData?.total_weight}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Added Bundles</div>
            <p>{outwardData?.added_bundles}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Added Bundles Pieces</div>
            <p>{outwardData?.added_bundles_pieces}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Added Bundles Weights</div>
            <p>{outwardData?.added_bundles_weight}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Ready Bundles</div>
            <p>{outwardData?.ready_bundles}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Ready Bundles Pieces</div>
            <p>{outwardData?.ready_bundles_pieces}</p>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Ready Bundles Weights</div>
            <p>{outwardData?.ready_bundles_weight}</p>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '10px',
            alignItems: 'center',
            gap: '30px',
            marginTop: '30px',
          }}
        >
          <div>
            <Col>
              <h2 style={{ margin: 0 }}>Added Bundles for Outwards</h2>
            </Col>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '10px',
              gap: '30px',
              marginTop: '30px',
            }}
          >
            <Col xs={24} md={8}>
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={searchRestore}
                onChange={handleSearchRestore}
                style={{ width: '100%' }}
              />
            </Col>
            <Tooltip
              title={
                selectedRowKeysRestore.length === 0
                  ? 'Select at least one item'
                  : ''
              }
            >
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => handleRestoreMultiple()}
                disabled={selectedRowKeysRestore.length === 0}
              >
                Restore Item
              </Button>
            </Tooltip>
            <div className="gridiconswrap">
              <Tooltip placement="topLeft" title="Column Filter Options">
                <Dropdown
                  overlay={columnMenuOne}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisibleOne}
                  onVisibleChange={setDropdownVisibleOne}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
            </div>
          </div>
        </div>
        <Table
          rowKey="id"
          rowSelection={rowSelectionRestore}
          columns={filteredColumnsOne}
          dataSource={restoreData || []}
          pagination={false}
          // pagination={{
          //   current: pageRestoreList,
          //   pageSize: pagesizeRestoreList,
          //   total: totalRestorePage,  // Use the correct total count
          //   showTotal: total => `Total ${total} items`,
          //   showSizeChanger: true,
          //   locale: { items_per_page: 'Items / Page' },
          // }}
          //onChange={handletableRestoreListchange}
          //pageSizeOptions={["20", "50", "100"]}
          loading={status === 'loading'}
          scroll={{ x: '600px' }}
        />
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '10px',
              alignItems: 'center',
              gap: '30px',
              marginTop: '30px',
            }}
          >
            <div>
              <Col>
                <h2 style={{ margin: 0 }}>Ready Bundles for Outwards</h2>
              </Col>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '10px',
                gap: '30px',
                marginTop: '30px',
              }}
            >
              <Col xs={24} md={8}>
                <Input
                  placeholder="Search"
                  className='searchbox'
                  prefix={<SearchOutlined />}
                  value={searchAdd}
                  onChange={handleSearchAdd}
                  style={{ width: '100%' }}
                />
              </Col>
              <Tooltip
                title={
                  selectedRowKeysAdd.length === 0
                    ? 'Select at least one item'
                    : ''
                }
              >
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleAddMultiple}
                  disabled={selectedRowKeysAdd.length === 0}
                >
                  Add Item
                </Button>
              </Tooltip>

              <div className="gridiconswrap">
                <Tooltip placement="topLeft" title="Column Filter Options">
                  <Dropdown
                    overlay={columnMenuTwo}
                    trigger={['click']}
                    placement="bottomRight"
                    visible={dropdownVisibleTwo}
                    onVisibleChange={setDropdownVisibleTwo}
                  >
                    <Button
                      type="primary"
                      icon={<ColumnList />}
                      onClick={e => e.preventDefault()}
                    />
                  </Dropdown>
                </Tooltip>
              </div>
            </div>
          </div>
          <Table
            rowKey="id"
            rowSelection={rowSelectionAdd}
            columns={filteredColumnsTwo}
            dataSource={outwardData?.bundles}
            pagination={false}
            // pagination={{
            //   current: page,
            //   pageSize: pagesize,
            //   total: totalAddPage, // Use the right total count
            //   showTotal: total => `Total ${total} items`,
            //   showSizeChanger: true,
            //   locale: { items_per_page: 'Items / Page' },
            // }}
            loading={status === 'loading'}
            //pageSizeOptions={["20", "50", "100"]}
            scroll={{ x: '600px' }}
            //onChange={handleTableChange}
          />
        </div>
      </div>
    </>
  );
}
